import { APP_INITIALIZER, NgModule } from '@angular/core';
import { AppComponent } from './app.component';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { SessionService } from './services/session.service';
import { CustomComponentsModule } from './commons/custom-components.module';
import { EjemplosModule } from './_ejemplos/ejemplos.module';
import { ContentRoutingModule } from './content/content-routing.module';
import { NavTabsComponent } from './nav-tabs/nav-tabs.component';
import { BrowserModule } from '@angular/platform-browser';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { AppRoutingModule } from './app-routing.module';

/** funcion de inicialización y carga de datos de la APP */
export function inicializeFactory(init: SessionService) {
  return () => init.iniciarApp();
}

@NgModule({
  declarations: [
    AppComponent,
    NavTabsComponent,
  ],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: inicializeFactory,
      deps: [SessionService],
      multi: true
    },
    {provide: LocationStrategy, useClass: HashLocationStrategy}],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    CustomComponentsModule,
    EjemplosModule,
  ]
})
export class AppModule {
  constructor(library: FaIconLibrary) {
    library.addIconPacks(fas);
  }
}
